{{#if showProgress}}
<div class="row">
    <div class="col-xs-12">

    {{#if writing}}
        <div class="m-t-10 m-b-20">
        {{#if cancelled}}
            {{TR "Schreibvorgang wird abgebrochen, bitte warten..."}}
        {{else}}
            {{TR "Werte werden geschrieben..."}}
        {{/if}}
        <i class="fa fa-spin fa-spinner"></i>
        </div>
    {{else}}
        {{#if cancelled}}
        <div class="alert alert-warning m-t-10">
            <b>{{TR "Schreibvorgang abgebrochen"}}:</b> {{numSuccess}}
            {{#COMPARE numSuccess '==' 1}}{{TR 'Wert'}}{{else}}{{TR 'Werte'}}{{/COMPARE}}
            {{TR "erfolgreich übertragen"}}, {{numFail}}
            {{#COMPARE numFail '==' 1}}{{TR 'Fehler'}}{{else}}{{TR 'Fehler-pl'}}{{/COMPARE}}.
        {{else}}
        {{#COMPARE numFail '>' 0}}
        <div class="alert alert-danger m-t-10">
            <b>{{TR "Schreibvorgang fehlgeschlagen"}}:</b> {{numSuccess}}
            {{#COMPARE numSuccess '==' 1}}{{TR 'Wert'}}{{else}}{{TR 'Werte'}}{{/COMPARE}} {{TR "erfolgreich übertragen"}}, {{numFail}}
            {{#COMPARE numFail '==' 1}}{{TR 'Fehler'}}{{else}}{{TR 'Fehler-pl'}}{{/COMPARE}}.
        {{else}}
        <div class="alert alert-success m-t-10">
            <b>{{TR "Schreibvorgang erfolgreich"}}:</b> {{numSuccess}}
            {{#COMPARE numSuccess '==' 1}}{{TR 'Wert'}}{{else}}{{TR 'Werte'}}{{/COMPARE}} {{TR "erfolgreich übertragen"}}.
        {{/COMPARE}}
        {{/if}}
        {{#COMPARE numFail '>' 0}}
        <div class="m-t-10">
            <button id="js-btn-retry" class="btn btn-sm btn-white">
                {{TR "Fehlgeschlagene Schreibvorgänge wiederholen"}}
            </button>
        </div>
        {{/COMPARE}}
        </div>
    {{/if}}

    {{#if writing}}
    {{TR "Gesamtfortschritt"}}:
    <div id="progressDone" class="progress progress-lg m-b-20">
        <div class="progress-bar progress-bar-primary" role="progressbar" style="width: {{percentDone}}%;">
        {{percentDone}} %
        </div>
    </div>
    {{TR "Erfolgreich"}}:
    <div id="progressSuccess" class="progress progress-lg m-b-20">
        <div class="progress-bar progress-bar-success" role="progressbar" style="width: {{percentSuccess}}%;">
        {{numSuccess}} / {{numTotal}} {{TR "Geräte"}}
        </div>
    </div>
    {{TR "Fehlgeschlagen"}}:
    <div id="progressFail" class="progress progress-lg m-b-20">
        <div class="progress-bar progress-bar-danger" role="progressbar" style="width: {{percentFail}}%;">
        {{numFail}} / {{numTotal}} {{TR "Geräte"}}
        </div>
    </div>
    {{/if}}

    </div>
</div>
{{/if}}
